import React from 'react'
import { css, cx } from '@emotion/css'
import { getColorValueCss, LoadingMaskColorValue } from '.'

export function LoadingMaskRectangle({
  flex,
  width,
  height,
  margin,
  borderRadius = 0,
  className,
  colorValue = 'normal',
  dataTestId
}: {
  flex?: string
  width?: number
  height?: number
  margin?: string
  borderRadius?: number
  className?: string
  colorValue?: LoadingMaskColorValue
  dataTestId?: string
}) {
  const widthCss = width
    ? css`
        width: ${width}px;
      `
    : css`
        width: 100%;
      `

  return (
    <div
      data-testid={dataTestId}
      className={cx(
        getColorValueCss(colorValue),
        widthCss,
        height
          ? css`
              height: ${height}px;
            `
          : undefined,
        css`
          flex: ${flex || 'none'};
          margin: ${margin || 0};
        `,
        borderRadius
          ? css`
              border-radius: ${borderRadius}px;
            `
          : undefined,
        className
      )}
    />
  )
}
